module.exports = __webpack_public_path__ + "img/no_vinculated_vehicle.3ee1b125.svg";